import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2026/Lic/C";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 006
        'numConvocatoria' : 'Convocatoria No. 006/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N16-2026.',
        'vigencia' : '30 de marzo al 10 de abril de 2026.',
        'descripcionProcedimiento' : 'Obra complementaria para la construcción de Puente en camino de acceso principal a la localidad El Piñal, San Bartolo Tutotepec.; ubicada en la localidad de El Piñal, Municipio de San Bartolo Tutotepec, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }6/N16/N16.rar`,
        'start' : '2026-03-30',
        'end' : '2026-04-10',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 005
        'numConvocatoria' : 'Convocatoria No. 005/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N15-2026.',
        'vigencia' : '23 de marzo al 6 de abril de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de carpeta asfáltica en el Boulevard Colonias - Santa Catarina, segunda etapa,municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }5/N15/N15.rar`,
        'start' : '2026-03-23',
        'end' : '2026-04-06',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N14-2026.',
        'vigencia' : '23 de marzo al 6 de abril de 2026.',
        'descripcionProcedimiento' : 'Construcción de Unidad Básica de Rehabilitación en la localidad de San Lorenzo Itztacoyotla, en el municipio de Juárez Hidalgo.; ubicada en la localidad de San Lorenzo Itztacoyotla, Municipio de Juárez Hidalgo, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }5/N14/N14.rar`,
        'start' : '2026-03-23',
        'end' : '2026-04-06',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N13-2026.',
        'vigencia' : '23 de marzo al 6 de abril de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de pavimento hidráulico, banquetas, guarniciones, alumbrado público, agua potable, drenaje sanitario en la Calle Heroico Colegio Militar, Colonia Centro, en el municipio de Tula de Allende.; ubicada en la localidad y Municipio de Tula de Allende, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }5/N13/N13.rar`,
        'start' : '2026-03-23',
        'end' : '2026-04-06',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N12-2026.',
        'vigencia' : '23 de marzo al 6 de abril de 2026.',
        'descripcionProcedimiento' : 'Construcción de Puente Nuevo Denominado La Romera, en el municipio de Tepeji del Río de Ocampo.; ubicada en la localidad de Tianguistengo (La Romera), Municipio de Tepeji del Río de Ocampo, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }5/N12/N12.rar`,
        'start' : '2026-03-23',
        'end' : '2026-04-06',
        'procedimiento' : 'Licitación Pública',
    },
]